import { Claims } from '../utils/services/cache/ClientCache'
const axios = require('axios');

export const getGroupAssignment = async () => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}Survey/GetSurveysByStudentNumber/${Claims.getGivenName()}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            //handle success
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const agreeTermsAndConditionsForSurvey = async (surveyId) => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}Student/AgreeTermsAndConditionsForSurvey/${surveyId}/${Claims.getGivenName()}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            //handle success
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};


export const getSurveySections = async (surveyId) => { 
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}SurveySection/GetSurveySections/${surveyId}/${Claims.getGivenName()}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            //handle success
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const getQuestion = async (snapshotId) => { 
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}SurveySection/GetQuestionsBySectionId/${snapshotId}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const postSurvey = async (bodyFormData) => {
    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}SurveySection/SubmitAnswersForSection`,
        data: bodyFormData,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const getSurveySummary = async (surveyId) => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}Survey/GetSurveySummary/${Claims.getGivenName()}/${surveyId}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            //handle success
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};